const fr = {
    //login
    greeting: "Si vous dépensez plus que vous ne gagnez, vous serez toujours pauvre.",
    username: "Nom d'utilisateur:",
    registration: "INSCRIPTION",
    log_required: "obligatoire",
    pass: "Mot de passe:",
    in: "SE CONNECTER",
    //registration
    required: "obligatoire",
    bevare_name_length: "Le nom d'utilisateur doit comporter au moins 4 caractères.",
    bevare_name_matches: "Le nom d'utilisateur ne peut contenir que des lettres latines et des chiffres.",
    bevare_pass_length: "Le mot de passe ne doit pas comporter moins de 4 caractères.",
    bevare_pass_matches: "Le mot de passe ne peut contenir que des lettres latines et des chiffres.",
    bevare_pass_check: "Les mots de passe ne correspondent pas.",
    reg_pass: "Mot de passe:",
    reg_to_log: "CONNEXION",
    check_pass: "Répétez le mot de passe:",
    reg_button: "S'INSCRIRE",
    reg_username: "Nom d'utilisateur:",
    //logined
    logined_trans_button_text: "Ajouter",
    logined_trans_list: "LISTE DES TRANSACTIONS:",
    //navbar
    new_transaction: "nouvelle transaction",
    transaction_statistic: "statistiques des transactions",
    transaction_history: "historique des transactions",
    calc: "calculatrice",
    //transaction
    transaction_date: "Date:",
    transaction_amount: "Montant:",
    transaction__details: "Détails:",
    //transaction form
    tf_data: "Date:",
    tf_type: "Type:",
    tf_expence: "Dépense",
    tf_income: "Revenu",
    tf_placeholder_target: "Objet de la dépense",
    tf_placeholder_amount: "Montant",
    tf_error: "Malheureusement, l'action a échoué. Veuillez réessayer plus tard.",
    tf_complite: "Enregistrement ajouté",
    //edit transaction
    et_update: "mettre à jour",
    et_cancel: "annuler",
    //delete transaction
    dt_delete: "Voulez-vous supprimer l'enregistrement?",
    dt_error: "Malheureusement, la suppression a échoué, veuillez réessayer plus tard.",
    dt_complite: "Enregistrement supprimé",
    //transaction controls
    tr_contrl_oldbegin: "Les plus anciens d'abord",
    tr_contrl_newbegin: "Les plus récents d'abord",
    tr_contrl_reload: "Recharger les données",
    tr_contrl_find: "Type de transaction recherchée",
    //summary
    sum_total_income: "Revenu total:",
    sum_total_expence: "Dépense totale:",
    sum_total_remain: " Reste:",
    sum_search_in_budget: "Recherche dans les dépenses:",
    sum_search: "Recherche",
    sum_summary_expenses_bytype: "Dépenses totales par type:",
    expence_by_month: "Dépenses par mois",
};

export default fr;
